import React from 'react';

const TrackingStats = ({ stats, selectedPeriod }) => {
  if (!stats) {
    return (
      <div className="stats">
        <div className="skeleton-card"><div className="skeleton skeleton-line number" /></div>
      </div>
    );
  }

  const maxByCategory = Math.max(...Object.values(stats.byCategory || {}), 1);

  return (
    <div className="stats">
      <div className="stat-card">
        <h3>Totale Eventi — {selectedPeriod === 'today' ? 'Oggi' : selectedPeriod === 'week' ? 'Settimana' : 'Mese'}</h3>
        <div className="stat-number">{stats.total}</div>
      </div>

      {Object.keys(stats.byCategory || {}).length > 0 && (
        <div className="stat-card">
          <h3>Per Categoria</h3>
          {Object.entries(stats.byCategory).sort((a, b) => b[1] - a[1]).map(([cat, count]) => (
            <div key={cat} className="stat-row">
              <span className="stat-row-label">{cat}</span>
              <div className="stat-row-bar">
                <div className="stat-row-bar-fill" style={{ width: `${(count / maxByCategory) * 100}%` }} />
              </div>
              <span className="stat-row-value">{count}</span>
            </div>
          ))}
        </div>
      )}

      {Object.keys(stats.byDay || {}).length > 0 && (
        <div className="stat-card">
          <h3>Per Giorno</h3>
          {Object.entries(stats.byDay).sort((a, b) => b[0].localeCompare(a[0])).map(([day, data]) => (
            <div key={day} className="stat-row">
              <span className="stat-row-label">{new Date(day + 'T00:00:00').toLocaleDateString('it-IT', { weekday: 'short', day: 'numeric', month: 'short' })}</span>
              <span className="stat-row-value">{data.total}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TrackingStats;
